<template>
<div class="chapter">
<div class="inner_page">
<p class="chapbreak">
</p><p class="copyright"><a id="pV">Copyright © 2013 Geoffrey Parker</a></p><a id="pV">
<p class="linespace">
</p><p class="copyright">All rights reserved. This book may not be reproduced in whole or in part, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press) without written permission from the publishers.</p>
<p class="linespace">
</p><p class="copyright">For information about this and other Yale University Press publications, please contact:</p>
</a><p class="copyright"><a id="pV">U.S. Office: </a><a href="mailto:sales.press@yale.edu">sales.press@yale.edu</a>      <a href="http://www.yalebooks.com" target="_blank">www.yalebooks.com</a></p>
<p class="linespace">
</p><p class="copyright">Europe Office: <a href="mailto:sales@yaleup.co.uk">sales @yaleup.co.uk</a>      <a href="http://www.yalebooks.co.uk" target="_blank">www.yalebooks.co.uk</a></p>
<p class="linespace">
</p><p class="copyright">Set in Arno Pro by IDSUK (DataConnection) Ltd</p>
<p class="copyright">Printed in Great Britain by TJ International Ltd, Padstow, Cornwall</p>
<p class="linespace">
</p><p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="linespace">
</p><p class="copyright">Parker, Geoffrey, 1943–</p>
<p class="copyright">   Global crisis: war, climate change and catastrophe in the seventeenth century/Geoffrey Parker.</p>
<p class="copyright">     pages cm</p>
<p class="copyright">   Includes bibliographical references.</p>
<p class="copyright">   ISBN 978-0-300-15323-1 (cloth: alkaline paper)</p>
<p class="copyright">1. History, Modern—17th century. 2. Military history—17th century. 3. Civil war—History—17th century. 4. Revolutions—History—17th century. 5. Climatic changes—Social aspects—History—17th century. 6. disasters—History—17th century. I. Title.</p>
<p class="copyright">   D247.P37 2012</p>
<p class="copyright">   909'.6—dc23</p>
<p class="copyright-r">2012039448</p>
<p class="linespace">
</p><p class="copyright">A catalogue record for this book is available from the British Library.</p>
<p class="linespace">
</p><p class="copyright">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004Copyright.vue?12c45ac0